import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

export const HeroSection = () => {
  const { t } = useLanguage();

  const scrollToNext = () => {
    const experienceSection = document.getElementById("experience");
    if (experienceSection) {
      experienceSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="home"
      className="min-h-[calc(100vh-4rem)] pt-20 md:pt-28 flex items-center justify-center px-6 relative"
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="relative inline-block mb-6">
            <div className="w-40 h-40 md:w-48 md:h-48 overflow-hidden rounded-full mx-auto mb-6 border-2 border-accent">
              <img
                src="/aditya.webp"
                alt="Aditya Kandele"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-2xl font-medium mb-2"
        >
          {t("hero.greeting")}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-white to-accent bg-clip-text text-transparent"
        >
          {t("root.title")}
        </motion.h1>

        <motion.h2
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-xl md:text-2xl font-medium mb-6 text-accent"
        >
          {t("hero.title")}
        </motion.h2>
        <motion.ul className="mb-6">
          <motion.li
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0, delay: 0 }}
            className="text-lg max-w-2xl text-accent"
          >
            {t("hero.subdescription1")}
          </motion.li>
          <motion.li
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0, delay: 0 }}
            className="text-lg max-w-2xl text-accent"
          >
            {t("hero.subdescription2")}
          </motion.li>
        </motion.ul>

        <motion.p
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0, delay: 0 }}
          className="text-lg text-muted-foreground max-w-2xl mx-auto mb-4"
        >
          {t("hero.description")}
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0, delay: 0 }}
          className="text-lg text-muted-foreground max-w-2xl mx-auto mb-10"
        >
          {t("hero.description1")}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <Button
            onClick={scrollToNext}
            size="lg"
            className="rounded-full animate-bounce mt-8"
            aria-label="Scroll to next section"
          >
            <ArrowDown className="h-5 w-5" />
          </Button>
        </motion.div>
      </div>

      <div className="absolute top-1/4 left-10 w-64 h-64 bg-accent/5 rounded-full filter blur-3xl"></div>
      <div className="absolute bottom-1/4 right-10 w-72 h-72 bg-accent/10 rounded-full filter blur-3xl"></div>
    </section>
  );
};
